module.exports = __webpack_public_path__ + "media/images/already-read-label-3b176ec026b41afa130695834107013d.png";